module.exports = {"511922001":"集州街道","511922101":"沙河镇","511922103":"长赤镇","511922104":"正直镇","511922105":"大河镇","511922106":"光雾山镇","511922108":"下两镇","511922109":"赶场镇","511922110":"杨坝镇","511922111":"天池镇","511922112":"关坝镇","511922113":"红光镇","511922114":"元潭镇","511922115":"赤溪镇","511922116":"八庙镇","511922117":"双流镇","511922118":"坪河镇","511922119":"桥亭镇","511922120":"和平镇","511922121":"侯家镇","511922122":"仁和镇","511922123":"高塔镇","511922125":"兴马镇","511922126":"关门镇","511922127":"石滩镇","511922128":"高桥镇","511922130":"贵民镇","511922131":"关路镇","511922132":"云顶镇","511922133":"公山镇","511922204":"团结乡","511922229":"神门乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511922.json
// module id = 2522
// module chunks = 0